<template>
  <div>
    <v-row>
      <v-col cols="6">
        <v-checkbox v-model="isSelectAll" :label="Translator('admin.notice_collection.facets.select_all')"></v-checkbox>
      </v-col>
      <v-col cols="5">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="float-right" color="primary" dark v-bind="attrs" v-on="on">
              {{ Translator('admin.notice_collection.facets.actions') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="openModal('putOnline')">
              <v-list-item-title>{{ Translator('admin.notice_collection.facets.switch_online') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openModal('putOffline')">
              <v-list-item-title>{{ Translator('admin.notice_collection.facets.switch_offline') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openModal('delete')">
              <v-list-item-title>{{ Translator('admin.notice_collection.facets.delete') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openModal('addToCollections')">
              <v-list-item-title>{{ Translator('admin.notice_collection.facets.add_to_collections') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openModal('removeFromCollections')">
              <v-list-item-title>{{ Translator('admin.notice_collection.facets.delete_to_collections') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col cols="12" v-if="isSelectAll">
        <v-alert border="left" color="indigo" dark>
          <p v-if="!isSelectAllQuery">{{ Translator('admin.notice_collection.facets.delete_to_collections', {'length': selectedNotices.length}) }}</p>
          <p v-if="isSelectAllQuery">{{ Translator('admin.notice_collection.facets.not_found_notices', {'length': totalNotices}) }}</p>
          <p>
            <v-btn @click="isSelectAllQuery = true" v-if="!isSelectAllQuery">{{ Translator('admin.notice_collection.facets.select_notices', {'length': totalNotices}) }}</v-btn>
          </p>
        </v-alert>
      </v-col>
    </v-row>
    <v-dialog
        v-model="isModalOpen"
        :persistent="isModalLock"
        width="650"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ Translator('admin.notice_collection.facets.grouped_actions') }}</span>
        </v-card-title>
        <v-card-text>
          <div v-if="isSelectAll && isSelectAllQuery">
            {{ Translator('admin.notice_collection.facets.grouped_actions_desc') }}:
            <ul>
              <li v-if="query">{{ Translator('admin.notice_collection.facets.query_search', {'query': query}) }}</li>
              <li v-if="onlyHasImage && onlyHasImage !== 'all'">{{ Translator('admin.notice_collection.facets.image_only') }}</li>
              <li v-if="selectedFacets.length > 0">Facets :
                <v-chip v-for="facet in selectedFacets" :key="facet.id" class="ma-2" label small>{{ facet.name }}</v-chip>
              </li>
              <li v-if="onlineFilter">Status :
                <v-chip v-if="onlineFilter === 'all'" label small>{{ Translator('admin.notice_collection.facets.filter_all') }}</v-chip>
                <v-chip v-if="onlineFilter === 'online'" label small>{{ Translator('admin.notice_collection.facets.filter_online') }}</v-chip>
                <v-chip v-if="onlineFilter === 'offline'" label small>{{ Translator('admin.notice_collection.facets.filter_offline') }}</v-chip>
              </li>
              <li v-if="noticeCollectionsFilter.length > 0">Collections :
                <v-chip v-for="collection in noticeCollectionsFilter" :key="collection.code" class="ma-2" label small>
                  {{ collection.code }}
                </v-chip>
              </li>
              <li>{{ Translator('admin.notice_collection.facets.filtered_results', {'length': totalNotices }) }}</li>
            </ul>
          </div>
          <div v-else>
            {{ Translator('admin.notice_collection.facets.action_make_on', {'length': selectedNotices.length }) }}
          </div>
          <v-select
              v-if="currentAction === 'addToCollections' || currentAction === 'removeFromCollections'"
              v-model="selectedCollections"
              :items="availableCollections"
              label="Collections"
              multiple
              chips
              persistent-hint
              item-text="name"
              item-value="code"
          ></v-select>
          <v-progress-linear v-if="progress > 0" :value="progress"></v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              v-if="currentAction === 'putOnline'"
              class="ma-2 pa-2"
              color="primary"
              text
              @click="putOnline"
              :loading="isLoading"
          >
            {{ Translator('admin.notice_collection.facets.switch_online') }}
          </v-btn>
          <v-btn
              v-if="currentAction === 'putOffline'"
              class="ma-2 pa-2"
              color="primary"
              text
              :loading="isLoading"
              @click="putOffline"
          >
            {{ Translator('admin.notice_collection.facets.switch_offline') }}
          </v-btn>
          <v-btn
              v-if="currentAction === 'delete'"
              class="ma-2 pa-2"
              color="primary"
              text
              :loading="isLoading"
              @click="deleteNotices"
          >
            {{ Translator('admin.notice_collection.facets.delete') }}
          </v-btn>
          <v-btn
              v-if="currentAction === 'addToCollections'"
              class="ma-2 pa-2"
              color="primary"
              text
              :loading="isLoading"
              @click="addToCollections"
          >
            {{ Translator('admin.notice_collection.facets.add_to_collections') }}
          </v-btn>
          <v-btn
              v-if="currentAction === 'removeFromCollections'"
              class="ma-2 pa-2"
              color="primary"
              text
              :loading="isLoading"
              @click="removeFromCollections"
          >
            {{ Translator('admin.notice_collection.facets.delete_to_collections') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import axios from 'axios'

import axios from 'axios'
import NoticeAPI from '@/api/notice'

export default {
  name: 'Actions',
  props: [
    'availableCollections',
    'query',
    'selectedFacets',
    'onlineFilter',
    'noticeCollectionsFilter',
    'totalNotices',
    'onlyHasImage'
  ],
  data () {
    return {
      isSelectAllQuery: false,
      resultPerPage: 30,
      progress: 0,
      currentAction: false,
      isModalOpen: false,
      isLoading: false,
      isModalLock: false,
      selectedCollections: []
    }
  },
  computed: {
    isSelectAll: {
      get () {
        return this.$store.state.selectAll
      },
      // setter
      set: function (newValue) {
        if(newValue){
          this.$emit('selectall')
        }
        else{
          this.isSelectAllQuery = false;
          this.$emit('unselectall')
        }
        this.$store.commit('selectAll', newValue)
      }
    },
    selectedNotices () {
      return this.$store.state.selectedNotices
    }
  },
  methods: {
    openModal (action) {
      this.isModalOpen = true
      this.currentAction = action
    },
    batchUpdate: async function (props) {
      this.isLoading = true
      this.progress = 1
      this.isModalLock = true
      let noticesData = []

      if(this.isSelectAll && this.isSelectAllQuery){
        let totalPages = Math.ceil(this.totalNotices / this.resultPerPage)

        for (let page = 1; page <= totalPages; page++) {
          const params = {
            query: this.query,
            page: page,
            f: this.selectedFacets.map(function (o) {return o.id}),
            items_per_page: this.resultPerPage,
            onlineFilter: this.onlineFilter,
            noticeCollectionsFilter: this.noticeCollectionsFilter.map(function (o) {return (o.code !== undefined) ? o.code : o}),
          };
          if(this.onlyHasImage !== 'all') params.onlyHasImage = this.onlyHasImage
          await axios
              .get('/api/v2/notices/search', { params })
              .then(async response => {
                let notices = response.data['hydra:member']
                notices.forEach((notice) => {
                  noticesData.push({...props, ...{id: notice.id}})
                })
                this.progress = Math.round((page / totalPages) * 70)
              })
        }
      }
      else if(this.selectedNotices.length > 0){
        this.selectedNotices.forEach((notice) => {
          noticesData.push({...props, ...{id: notice}})
        })
      }

      let i, j, temporary, chunk = 100
      for (i = 0, j = noticesData.length; i < j; i += chunk) {
        temporary = noticesData.slice(i, i + chunk)
        await NoticeAPI.updates(temporary).then(response => {
          if (response.status === 200) {
            this.progress = 70 + Math.round((i / noticesData.length) * 30)
          }
        })
      }

      this.progress = 0
      this.isLoading = false
      this.isModalOpen = false
      this.isModalLock = false
      this.selectedCollections = []
      this.$emit('finished')
    },
    splitArrayIntoChunksOfLen (arr, len) {
      let chunks = [], i = 0, n = arr.length
      while (i < n) {
        chunks.push(arr.slice(i, i += len))
      }
      return chunks
    },
    async putOnline () {
      await this.batchUpdate({isEnabled: true})
    },
    async putOffline () {
      await this.batchUpdate({isEnabled: false})
    },
    async deleteNotices () {
      await this.batchUpdate({delete: true})
    },
    async addToCollections () {
      await this.batchUpdate({addCollections: this.selectedCollections})
    },
    async removeFromCollections () {
      await this.batchUpdate({removeCollections: this.selectedCollections})
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
}
</script>
